module.exports = __webpack_public_path__ + "img/reset-password-03.79127abb.png";